import { Box, Grid, Paper, Typography } from "@mui/material";
import TitleHeaders from "../../../Components/CluppForms/TitleHeaders";
import FacebookIcon from "@mui/icons-material/Facebook";
import GoogleIcon from "@mui/icons-material/Google";
import AndroidIcon from "@mui/icons-material/Android";
import AppleIcon from "@mui/icons-material/Apple";
import { Link } from "react-router-dom";
import WhatsAppButton from "../../../Components/CluppForms/WhatsappButton";

const CluppReview = ({ state, setState }) => {
  return (
    <>
      <TitleHeaders title={"¡Muchas gracias ❤️!"} />
      <Typography variant="h6" gutterBottom>
        Gana hasta $600{" "}
        <span role="img" aria-label="star eyes">
          🤩
        </span>
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        Una reseña tuya en nuestras redes sociales es muy valiosa para nosotros.
        Para agradecerte, te damos $200 por cada reseña que pongas. Solo
        necesitas tomar una captura de pantalla de cada reseña y enviárnosla por
        WhatsApp al{" "}
        <a
          href="https://wa.me/5215577460177"
          target="_blank"
          rel="noreferrer"
          style={{ color: "#2CC1F0" }}
        >
          5577460177
        </a>{" "}
        <span role="img" aria-label="party hat">
          🥳
        </span>{" "}
        ¡Tu opinión cuenta y nos ayuda a mejorar!
      </Typography>

      <Box sx={{ marginTop: 1, marginBottom: 2 }}>
        <Grid
          container
          spacing={2}
          justifyContent="center"
          sx={{ marginTop: "10px" }}
        >
          <Grid item xs={6}>
            <Paper
              elevation={1}
              sx={{
                display: "flex",
                alignItems: "center",
                padding: 1,
                marginBottom: 1,
                fontSize: "18px",
                fontWeight: 600,
              }}
            >
              <FacebookIcon
                sx={{ marginRight: 1, color: "#4267B2" }}
                fontSize="large"
              />
              <a
                href="http://facebook.com/cluppseguro/reviews"
                target="_blank"
                rel="noreferrer"
                style={{ color: "#000", textDecoration: "none" }}
              >
                Facebook
              </a>
            </Paper>
          </Grid>
          <Grid item xs={6}>
            <Paper
              elevation={1}
              sx={{
                display: "flex",
                alignItems: "center",
                padding: 1,
                marginBottom: 1,
                fontSize: "18px",
                fontWeight: 600,
              }}
            >
              <GoogleIcon
                sx={{ marginRight: 1, color: "#DB4437" }}
                fontSize="large"
              />
              <a
                href="https://g.page/r/CQYkTGZh8_9xEB0/review"
                target="_blank"
                rel="noreferrer"
                style={{ color: "#000", textDecoration: "none" }}
              >
                Google
              </a>
            </Paper>
          </Grid>
        </Grid>

        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={6}>
            <Paper
              elevation={1}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 1,
                fontSize: "18px",
                fontWeight: 600,
              }}
            >
              <AndroidIcon
                sx={{ marginRight: 1, color: "#3DDC84" }}
                fontSize="large"
              />
              <a
                href="https://play.google.com/store/apps/details?id=mx.com.clupp.autoclupp"
                target="_blank"
                rel="noreferrer"
                style={{ color: "#000", textDecoration: "none" }}
              >
                Android Play Store
              </a>
            </Paper>
          </Grid>
          <Grid item xs={6}>
            <Paper
              elevation={1}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 1,
                fontSize: "18px",
                fontWeight: 600,
              }}
            >
              <AppleIcon
                sx={{ marginRight: 1, color: "#A2AAAD" }}
                fontSize="large"
              />
              <a
                href="https://apps.apple.com/mx/app/clupp/id1451145803"
                target="_blank"
                rel="noreferrer"
                style={{ color: "#000", textDecoration: "none" }}
              >
                iPhone App Store
              </a>
            </Paper>
          </Grid>
        </Grid>
        <WhatsAppButton
        title={"Notificar reseña"}
        link={
          "https://wa.me/5215577460177"
        }
      />
      </Box>
    </>
  );
};

export default CluppReview;
